import axios from 'axios';
import {authInterceptor} from './auth/AuthInterceptor'
const httpClient = axios.create({});
httpClient.interceptors.request.use(authInterceptor.intercept);


export default httpClient;
